module.exports = __webpack_public_path__ + "static/media/4.dd6d7062.png";